import SbsSuiteContainer from 'SbsSuite/Container/SbsSuiteContainer';

export default SbsSuiteContainer;
